<div class="status-bar" data-cy="status-bar">
  <div class="status-bar-container">
    @if (emptyBar) {
      <app-tooltip [attr.data-cy]="'status-bar-empty'" [dynamic]="false" message="Empty">
        <div class="status-bar-empty"></div>
      </app-tooltip>
    }
    <app-tooltip [message]="getTooltipStrings()" [dynamic]="false" [orderedList]="false">
      @if (!emptyBar) {
        <div class="status-bar-full">
          @for (state of statusArray; track state) {
            <div
              [ngClass]="['status-bar-status', 'status', state.code]"
              [ngStyle]="{'width': getStatusPercentage(state.value, totalMaterials) + '%'}"
            [attr.data-cy]="'status-bar-section-' + state.code"></div>
          }
        </div>
      }
    </app-tooltip>
  </div>
</div>
